import React, { useState } from 'react'
import classNames from 'classnames'
import { IconChevronDown, IconLock } from '@tabler/icons-react'

/**
 * A collapsed, read-only `<system>` section of a prompt. Shared by the read
 * display and the editor so the PE sees the section in the same place in both.
 *
 * @param {object} props.segment the system segment (`{ index, content }`)
 * @param {React.ReactNode} [props.children] body to render when expanded; defaults to the raw content
 */
const SystemSegmentBar = ({ segment, children }) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div
      className={classNames('voice-agents__segmented-prompt-system', {
        'voice-agents__segmented-prompt-system--open': isOpen,
      })}
      data-testid={`segment-system-${segment.index}`}
    >
      <button
        type="button"
        className="voice-agents__segmented-prompt-system-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
      >
        <IconLock size={12} aria-hidden="true" />
        <span>System section{isOpen ? '' : ' (read-only)'}</span>
        <IconChevronDown
          size={12}
          aria-hidden="true"
          style={{ transform: isOpen ? 'rotate(180deg)' : '' }}
        />
      </button>
      {isOpen && (
        <pre
          className="voice-agents__segmented-prompt-system-body"
          data-testid={`segment-system-body-${segment.index}`}
          data-segment-index={segment.index}
        >
          {children ?? segment.content}
        </pre>
      )}
    </div>
  )
}

export default SystemSegmentBar
